import FallbackLoader from '../FallbackLoader';

export default FallbackLoader(() => import(/* webpackChunkName: "async-MetroStops" */'@modals/partials/cerca-casa/MetroStops'));
